import { DeveloperDataOptions } from "../../../config/developerData";

function formatDuration(value) {
  const milliseconds = Number(value || 0);
  if (!Number.isFinite(milliseconds) || milliseconds < 1000) return `${Math.max(0, Math.round(milliseconds))} мс`;
  return `${(milliseconds / 1000).toFixed(milliseconds >= 10_000 ? 0 : 1)} с`;
}

function formatCount(value) {
  const count = Number(value);
  return Number.isFinite(count) ? new Intl.NumberFormat("ru-RU").format(count) : "";
}

export default function MapLoadIndicator({ state }) {
  const active = Boolean(state?.active);
  const last = state?.last || null;
  if (!active && !(DeveloperDataOptions.mapLoadDetails && last)) return null;

  const activeLabel = state?.label || "данные карты";
  const progress = Math.max(0, Math.min(100, Math.round(Number(state?.progress) || 0)));
  const loaded = Number(state?.loaded);
  const total = Number(state?.total);
  const progressText = Number.isFinite(loaded) && Number.isFinite(total) && total >= 0
    ? `${progress}% · ${formatCount(loaded)} из ${formatCount(total)}`
    : `${progress}%`;
  const title = active
    ? `Загрузка: ${activeLabel}`
    : last?.error
      ? `Ошибка загрузки: ${last.label || "данные карты"}`
      : `Загружено: ${last?.label || "данные карты"}`;
  const phaseText = last && !last.error && Number.isFinite(Number(last.renderDurationMs))
    ? `API ${formatDuration(last.readyDurationMs)} · передача ${formatDuration(last.transferDurationMs)} · отрисовка ${formatDuration(last.renderDurationMs)} · всего ${formatDuration(last.totalDurationMs)}`
    : "";
  const developerText = last
    ? `${last.label || "Данные карты"}: ${last.error ? "ошибка" : `${formatCount(last.count)} объектов`} · ${phaseText || formatDuration(last.durationMs)}`
    : "Ожидание данных карты…";

  return (
    <div className={`map-load-indicator${active ? " is-active" : ""}`} role="status" aria-live="polite" title={title}>
      {active ? <span className="map-load-spinner" aria-hidden="true" /> : null}
      <span className="visually-hidden">{title}</span>
      {active && DeveloperDataOptions.mapLoadDetails ? (
        <span className="map-load-progress-wrap">
          <span className="map-load-public-text">Загрузка: {activeLabel} · {progressText}</span>
          <span className="map-load-progress-track" aria-hidden="true">
            <span className="map-load-progress-value" style={{ width: `${progress}%` }} />
          </span>
        </span>
      ) : null}
      {DeveloperDataOptions.mapLoadDetails ? <span className="map-load-developer-text">{developerText}</span> : null}
    </div>
  );
}
